import ImageGridViewer from "./components/ImageGridViewer.vue";

const ImageGrid = {
    install(Vue) {
        // Let's register our component globally
        // https://vuejs.org/v2/guide/components-registration.html
        Vue.component("image-grid-viewer", ImageGridViewer);
    }
};

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(ImageGrid);
}

export default ImageGrid;